// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

// Configure Dropzone globally
import Dropzone from "dropzone"
Dropzone.autoDiscover = false

